export default __webpack_public_path__ + "static/media/J736_RoHS.8ceb36e7.pdf";